import { render, staticRenderFns } from "./CsTags.vue?vue&type=template&id=22e3b8d5&scoped=true&"
import script from "./CsTags.vue?vue&type=script&lang=js&"
export * from "./CsTags.vue?vue&type=script&lang=js&"
import style0 from "./CsTags.vue?vue&type=style&index=0&id=22e3b8d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e3b8d5",
  null
  
)

export default component.exports